import React from 'react'

import {tableSchema} from '../../services/EntityTableSchema'
import {actionSchema} from '../../services/EntityRowActionsSchema'
import {atcs_get_quotations} from '../../services/BE'

import DashboardCard from '../../@react-fefmwk/cards/modules/DashboardCard'
import Table from '../../@react-fefmwk/tables/modules/Table'
import AdapterLink from '../../@react-fefmwk/links/modules/AdapterLink'

import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import ErrorIcon from '@material-ui/icons/Error'
import AddIcon from '@material-ui/icons/Add'

class WidgetAtcQuotations extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            quotations: [],
        }
    }
    
    async updateQuotations() {
        const id_atc = this.props.id_atc
        if( id_atc ) {
            this.setState({
                quotations: await atcs_get_quotations(id_atc),
            })
        }
    }
    
    async componentDidMount() {
        this.updateQuotations()
    }
    
    async componentDidUpdate(prevProps) {
        const id_atc = this.props.id_atc
        if( id_atc !== prevProps.id_atc )
            this.updateQuotations()
    }

    render() {
        const id_atc = this.props.id_atc
        const quotations = this.state.quotations

        const dashboardcardActions = this.props.hasOwnProperty('dashboardcardActions')
            ? this.props.dashboardcardActions
            : true
        const dashboardcardTitle = this.props.dashboardcardTitle
                ? this.props.dashboardcardTitle
                : "Quotations"

        const quotationsRowActions = actionSchema('insurances_quotations')
        const fieldsProps = tableSchema('insurances_quotations')

        const cardProps = {}
        cardProps['Content'] = quotations.length
            ? <Table material dense
                data={quotations}
                fieldsProps={fieldsProps}
                rowActions={quotationsRowActions}
                showPagination={true}
                defaultPageSize={15}
                rowActionsField="id_insurance_quotation"
            />
            : <Chip icon={<ErrorIcon />} label="Nessuna quotazione disponibile" variant="outlined" />

        if( dashboardcardActions )
            cardProps['TopActions'] = <Button
                variant="text" color="primary" size="small"
                startIcon={<AddIcon fontSize="small" />}
                component={AdapterLink}
                to={"/insurances_quotations/add?id_atc="+id_atc}
            >Nuova</Button>

        return <DashboardCard title={dashboardcardTitle} {...cardProps} />
    }
}

export default WidgetAtcQuotations